import { Button, buttonVariants } from "@/components/ui/button";
import { useAuth } from "@/providers/auth.provider";
import { AuthState } from "@/types/auth.types";
import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useWindowScroll } from "react-use";
import { Skeleton } from "../ui/skeleton";

export default function Navbar() {
  const { authState } = useAuth();

  const { y } = useWindowScroll();
  const [isOutOfHero, setIsOutOfHero] = useState(false);

  useEffect(() => {
    if (y > 100) {
      setIsOutOfHero(true);
    } else {
      setIsOutOfHero(false);
    }
  }, [y]);

  return (
    <nav
      className={`fixed w-full ${
        isOutOfHero
          ? "backdrop-blur-xl shadow-md z-30"
          : "backdrop-blur-md z-30"
      }`}
    >
      <div className="flex items-center justify-between w-full px-10">
        <img
          src={"/logo.png"}
          alt="logo"
          width={100}
          height={100}
          className="w-20"
        />
        <div className="flex gap-x-4">
          {authState === AuthState.AUTHENTICATED && (
            <Link to="/dashboard" className={buttonVariants()}>
              Dashboard
            </Link>
          )}

          {authState === AuthState.AUTHENTICATING && (
            <Skeleton className="w-9 h-9 rounded-full" />
          )}

          {authState === AuthState.UNAUTHENTICATED && (
            <>
              <Link to={"/login"}>
                <Button
                  type="button"
                  variant="outline"
                  className="hover:bg-gray-50 h-9 shadow hidden md:block"
                >
                  Log in
                </Button>
              </Link>

              <Link to={"/register"}>
                <Button
                  type="button"
                  className="bg-primary hover:bg-primary/80 h-9"
                >
                  {"Sign Up"}
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
